/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
export interface GenericMap<T> {
  [key: string]: T;
}

export type StringMap = GenericMap<string>;
export type BooleanMap = GenericMap<boolean>;
export type NumberMap = GenericMap<number>;
